import styled from 'styled-components/macro';

export const Container = styled.div`
  &:not(:last-child) {
    margin-bottom: 1px;
  }
`;
